import configPathDefault from "./config-path.js";
/**
 * configuration
 */
let config = null;
/**
 * initialize configuration
 * load configuration source
 */
export async function init(configPath) {
    if (!config) {
        if (!configPath) {
            configPath = configPathDefault;
        }
        const configPathUrl = configPath.trim();
        const res = await fetch(configPathUrl);
        if (res.ok) {
            config = await res.json();
        }
    }
}
/**
 * get request path
 */
export function getRequestPath() {
    let result;
    if (config) {
        result = config.requestPath;
    }
    return result;
}
// vi: se ts=2 sw=2 et:
